"use runtime-nodent"

import init from "init/application"
import "static/static"
// Shared carousel styles - imported before components so component overrides take precedence
import "utils/_carousel.scss"
import "styles/utils.scss"

import "components/affiliate-fillers/affiliate-fillers"
import "components/gallery-photo-upload/gallery-photo-upload"
import "components/affiliate-banner-header/affiliate-banner-header"
import "components/panel/panel"
import "components/elevation-with-mountain/elevation-with-mountain" // TODO: is it used somewhere?
import scrollButton from "components/scroll-button/scroll-button"
import switchUnits from "components/switch-units"
import tooltip from "components/tooltip"
import forecastTable from "components/forecast-table"
import "components/incentive/incentive"
import "components/snow-alert-subscription/snow-alert-subscription"
import "components/resort-rating/resort-rating"
import "components/resort-review/resort-review"
import snowhist from "components/snowhist"
import reviewVotes from "components/review-votes/review-votes"
import reviewSortLinks from "components/review-sort-links/review-sort-links"
import snowConditions from "components/snow-conditions/snow-conditions"
import "components/resort-snow-report/resort-snow-report"
import "components/resort-snowfall-snippet/resort-snowfall-snippet"
import "components/resort-snow-depths-snippet/resort-snow-depths-snippet"
import "components/resort-condition/resort-condition"
import "components/stars-bar/stars-bar"
import { PageHeader } from "components/page-header"
import { LocationSubheader } from "components/location-subheader"
import "components/location-background"
import forecastUserControl from "components/forecast-user-control"
import liveSnow from "components/live-snow/live-snow"
import resortNearbyResorts from "components/resort-nearby-resorts/resort-nearby-resorts"
import "components/elevation-mountain/elevation-mountain"
import "components/ski-discount-table/ski-discount-table"
import "components/ski-hire-iframe/ski-hire-iframe"
import "components/ski-hire-directory/ski-hire-directory"
import "components/ski-hire-promo/ski-hire-promo"
import "components//ski-hire-bar"
import "components//intersport-voucher"
import "components//alpine-fleet-widget"
import "components/easter-header/easter-header"
import "components/easter-infographic/easter-infographic"
import rewardsHeader from "components/rewards-header/rewards-header"
import "components/resort-guide/resort-guide"
import "components/resort-guide-text"
import "components/app-promo"
import collapsible from "components/collapsible/collapsible"
import gallerySortLinks from "components/gallery-sort-links/gallery-sort-links"
import "components/advertise-header/advertise-header"
import "components/advertise-contact/advertise-contact"
import "components/advertise-markets/advertise-markets"
import "components/membership-page/membership-page"
import "components/media-kit/media-kit"
import moneySavingTips from "components/money-saving-tips/index"
import "components/closing-infographics"
import "components/hindcast-prompt"
import scrollFade from "components/scroll-fade"
import { Nearby } from "components/nearby"
import { Carousel } from "components/carousel"
import "components/distance-range-slider"
import "components/snow-icon"
import "components/snow-icon-static"

import { ResortWebcams } from "components/resort-webcams"
import { WindIcon } from "components/wind-icon"
import "components/weather-icon"
import login from "components/login/login"
import "components/login"
import galleryPhoto from "components/gallery-photo"
import "components/intersport-discount-page"
import "components/intersport-discount-page/promo-article"

import "components/buttons"
import "components/app-buttons"
import "components/outside-buttons"
import "components/apple-buttons"
import "components/google-buttons"
import "components/gallery-thumbnails"
import "components/gallery-upload-button"
import "components/votes-bar"
import "components/comment-votes"
import "components/pagination"
import "components/picks"
import "components/featured-photos"
import "components/outside-promo-page"
import "components/outside-page"
import "components/nearest-ski-resorts-with-webcams"
import { Smartbar } from "components/smartbar"
import { ModalAppPopup } from "components/modal-app-popup"
import "components/my-details"
import "components/my-subscription"
import { Weski } from "components/weski"
import { Signup } from "components/signup-page"
import signup from "components/signup"
import rewards from "components/rewards"

import { ResortFinder } from "components/resort-finder"
import "components/flag"
import { Buttons } from "components/controls"
import "components/star-rating"

import snowReportPage from "components/snow-report-page"
import snowHistoryPage from "components/snow-history"
import { Map } from "components/leaflet"
import "components/snow-amount"
import "components/homepage-hero"
import "components/user-avatar"
import { AccordionReviews } from "components/accordion-reviews"
import "components/carousel-news-posts"
import { FeatureNewsPosts } from "components/feature-news-posts"
import { initWebcamPopup } from "components/webcam-popup"
import "components/carousel-resort-picks"
import "components/carousel-photo-gallery"
import "components/promo-premium"
import "components/promo-app"
import "components/snow-maps-seo-section"
import "components/affiliate-bar"
import { ForecastTextSummary } from "components/text-summaries"
import { ResortDropdowns } from "utils/resort-dropdowns"

// Temporary from NL
// import { Footer } from "components/nl/page-footer"

// eslint-disable-next-line import/first, import/no-unresolved
import "fc-ads/fc-ads.scss"

const meta = document.querySelector("meta[name=csrf-token]")
const token = meta ? meta.content : ""

const runOnInteractive = async () => {
  init()
  PageHeader.init(document.body)
  LocationSubheader.init(document.body)
  forecastUserControl()
  liveSnow()
  scrollFade()
  switchUnits()
  tooltip()
  forecastTable()
  snowhist()
  scrollButton()
  reviewVotes()
  reviewSortLinks()
  snowConditions()
  resortNearbyResorts()
  snowReportPage()
  snowHistoryPage()
  collapsible()
  gallerySortLinks()
  ResortWebcams.init(document.body)
  WindIcon.init(document, {})
  Nearby.init(document.body, {})
  Smartbar.init(document.body)
  ModalAppPopup.init(document.body)
  Signup.init(document.body)
  Carousel.init(document.body)
  AccordionReviews.init(document.body)
  Buttons.init(document.body)
  ResortFinder.init(document.body)
  FeatureNewsPosts.init(document.body)
  ForecastTextSummary.init(document.body)
  initWebcamPopup(document.body)
  ResortDropdowns.init(document.body, {
    feature: ".js-dropdown-feature",
    location: ".js-dropdown-location",
  })
}

const runOnLoad = () => {
  rewards()
  signup()
  moneySavingTips()
  rewardsHeader()
  login()
  galleryPhoto({
    token,
    loggedIn: window.FCGON.logged_in,
    memberMode: window.FCGON.member_mode,
    location: window.FCGON.location_filename,
  })
  Map.init(document.body, {
    level: window.FCGON.level,
    isMemberMode: window.FCGON.member_mode,
    mapConfigList: window.FCGON.maps,
  })
  Weski.init(document.body)
}

// `DOMContentLoaded` may fire before your script has a chance to run, so check before adding a listener
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runOnInteractive)
} else {
  // `DOMContentLoaded` already fired
  runOnInteractive()
}

if (document.readyState === "loading" || document.readyState === "interactive") {
  window.addEventListener("load", runOnLoad)
} else {
  // window.load already fired
  runOnLoad()
}
